import { Component, Shark, Utils } from "shark-mvc";
import $ from "jquery";
import moment from "moment";

import templateContent from "./information-modal.html";

class InformationModalComponent extends Component {
	constructor () {
		super("informationModalComponent");
		this.addTemplate("", templateContent);
	}




	
	afterRender () {
		if (this.get("open")) {
			$("#informationModal").modal("show");
		}
	}

	show (data = {body: "", title: "Informazione"}) {
		const currInformationForModal = Shark.get("currInformationForModal");

		currInformationForModal.set({
			body: data.body,
			title: data.title,
		});

		//console.log({data, currInformationForModal})

		$("#informationModal").modal("show");
		this.set("open", true);
	}

	informationModalCloseBtn_clickHandler () {
		$("#informationModal").modal("hide");
		this.set("open", false);
	}

	init () {
		const currInformationForModal = Shark.getInstance("__smart__", {
			body: "",
			title: "",
		});

		this.set("open", false);
		Shark.set({currInformationForModal});
	}
}

const informationModalComponent = new InformationModalComponent();

Shark.registerComponent(informationModalComponent);

export { informationModalComponent };
